import React from "react";
import { useDrag, useDrop } from "react-dnd";
import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import StarIcon from "@mui/icons-material/Star";
import { format, parseISO } from "date-fns";
import { removePins } from "../../redux/slices/mapPins";
import { getTripResults } from "../../redux/slices/trips";
import { useDispatch } from "react-redux";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
const DropAreaItenary = ({ onDrop, atd, tripId }) => {
  const dispatch = useDispatch();
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "PIN", // Only accept items of type "PIN"
    drop: (item) => onDrop(item, atd), // Handle drop event
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  }));

  const deletePins = (id) => {
    dispatch(removePins({ id, tripId }));
    dispatch(getTripResults({ tripId }));
  };

  const RenderItem = (item, index) => {
    const [{ isDragging }, drag] = useDrag(() => ({
      type: "PIN",
      item: { index, ...item }, // Pass item data when dragging
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }));

    return (
      <div
        key={index}
        ref={drag}
        className="policy-item mt-4 "
        style={{ opacity: isDragging ? 0.5 : 1 }}
      >
        {/* <span
          className="separator-text fs-6"
          style={{
            position: "absolute",
            top: "-20px",
            transform: "rotate(-90deg)",
            transformOrigin: "left center",
          }}
        >
          {item?.distanceFromPrevious}
        </span> */}

        <div className="policy-icon">
          {item?.type === "flight" && (
            <FlightIcon style={{ color: "var(--primary-color)" }} />
          )}
          {item?.type === "hotel" && (
            <HotelIcon style={{ color: "var(--primary-color)" }} />
          )}
          {item?.type === "pin" && (
            <LocationOnIcon style={{ color: "var(--primary-color)" }} />
          )}
        </div>

        {item?.type === "flight" && (
          <div className="d-flex align-items-start pe-2">
            <div style={{ width: "15%", height: "15%" }}>
              <img
                src={item?.imgs}
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                }}
                className="border-radius-6px "
                alt=""
              />
            </div>
            <div className="w100 ms-3">
              <div className="d-flex align-items-center ">
                <h3 className="me-3">{item?.arrival.location}</h3>
                <FlightTakeoffIcon />
                <h3 className="ms-3">{item?.departure.location}</h3>
              </div>
              <div className="d-flex align-items-center justify-content-between mt-2 df-wrap">
                <p className="fs-8">{item?.airport}</p>
                <p className="fs-8 ms-2">
                  {item.arrival.date}{" "}
                  <span className="ms-2">{item?.arrival?.time}</span>
                </p>
                <p className="fs-8">Terminal- {item?.departure?.terminal}</p>
              </div>
            </div>
          </div>
        )}

        {item?.type === "hotel" && (
          <div className="pin-container">
            <div className="d-flex align-items-start pe-2">
              <div style={{ width: "15%", height: "15%" }}>
                <img
                  src={item?.heroImage}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                  }}
                  alt=""
                  className="border-radius-6px"
                />
              </div>
              <div className="w100 ms-3">
                <h3>{item.name}</h3>
                <div className="d-flex align-items-center justify-content-between df-wrap">
                  <p className="fs-8">{item?.roomsAndRates?.name}</p>
                  <div className="d-flex align-items-center">
                    <p className="fs-8 ms-2">
                      {format(new Date(item?.checkin), "EEE, dd MMM")}
                    </p>
                    <p>-</p>
                    <p className="fs-8 ms-2">
                      {" "}
                      {format(new Date(item?.checkout), "EEE, dd MMM")}
                    </p>
                  </div>
                  {/* <p className="fs-8">Shubham +4</p> */}
                </div>
              </div>
            </div>
          </div>
        )}

        {item?.type === "pin" && (
          <div className="pin-container">
            <div className="delete-icon-cont">
              <DeleteForeverIcon onClick={() => deletePins(item._id)} />
            </div>
            <div className="d-flex align-items-start pe-2">
              <div>
                <img
                  src={item?.image}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",
                  }}
                  alt=""
                  className="border-radius-6px"
                />
              </div>

              <div className="w80 ms-3">
                <h3>{item.name}</h3>
                <p className="fs-8">{item?.address}</p>
                {/* <p className="fs-8"> {item?.distanceFromPrevious}</p> */}
              </div>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ gap: 5 }}
              >
                <p className="fs-8 t-center">{item?.distanceFromPrevious}</p>

                <StarIcon style={{ color: "var(--yellow-color)" }} />
                <p className=" mt-1 fw-700 ">{item?.rating}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      key={atd?.id}
      className="row bxShadow mt-3"
      style={{
        background: "var(--white-color)",
        borderRadius: "4px",
        position: "relative",
        minHeight: "10rem",
      }}
      ref={drop}
    >
      <div className="col-md-12   p-0">
        <div
          className=""
          style={{
            // position: "absolute",
            // zIndex: "11",
            background: "var(--yellow-color)",
            // top: "38%",
            // top: "38%",
            textAlign: "center",
            color: "var(--white-color)",
            padding: "8px 10px",
            // borderTopRightRadius: "6px",
            // borderBottomRightRadius: "6px",
          }}
        >
          <p className="fw-700">
            {atd?.date ? format(parseISO(atd.date), "dd") : ""}{" "}
            {atd?.date ? format(parseISO(atd.date), "MMM") : ""}
          </p>
          {/* <p className="m-0 p-0 fw-700"></p> */}
        </div>
        <div className="px-3">
          {atd?.tripItinerary?.length === 0 ? (
            <div
              style={{
                // marginLeft: "60px",
                background: "#dadada",
                opacity: "0.4",
                height: "8rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Drag a Pin from top to add an event
            </div>
          ) : (
            atd?.tripItinerary?.map((item, index) => RenderItem(item, index))
          )}
        </div>
      </div>
    </div>
  );
};

export default DropAreaItenary;
